import React from "react";
import TextInput from "../inputs/text-input";
import Parser from "application/components/parser";

const UserData = (props) => {
  const { form, register, errors, display, setOnFocus } = props;

  return (
    <div className="form__form-wrapper-user">
      <div className="form__form-body-users" style={{ display: display ? "block" : "none" }}>
        <div className="field-creator__field-container-group">
          <TextInput
            path={"name.value"}
            name={`${form.name.name}`}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          <TextInput
            path={"surname.value"}
            name={`${form.surname.name}`}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          <TextInput
            path={"email.value"}
            name={`${form.email.name}`}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          <TextInput
            path={"mobile.value"}
            name={`${form.mobile.name}`}
            register={register}
            errors={errors}
            users
            isNumber
            setOnFocus={setOnFocus}
          />
          <div className="form_data__accept">
            <Parser text={form.read_terms.name} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserData;
